import React, { useState } from "react";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import CommonCropImage from "components/commonCropImage/CommonCropImage";
import camera from "assets/images/camera.svg";
import profile from "assets/images/SubVendorLogo.svg";

function CommonCropUpload(props) {
  const [src, setSrc] = useState(null);
  // modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [imgError, setImgError] = useState('');
  const [imgPlaceholder, setImgPlaceholder] = useState(true);
  const [imageObj, setImageObj] = useState({});
  const [fileTypeError, setFileTypeError] = useState('');
  const {register} = useForm()
  const handleErrorImg = (event) => {
    const typeError = 'Please choose proper image'
    setFileTypeError(typeError)
    setModalOpen(false)
  }

  const onImageChange =(event) =>{
   setFileTypeError('');
   if (event.target.files && event.target.files[0]) {
     const img = event.target.files[0];
     setImageObj(event.target.files[0])
     const attributeType = ['image/jpeg', 'image/png'];
 
     if (!attributeType.includes(img.type)) {
       const typeError = 'File type should be in png/jpg/jpeg';
       setFileTypeError(typeError);
       setImgPlaceholder(true);
     } else if (event.target.files[0].size > 1024000) {
       const errorVal = 'Image size should not be more than 1 MB';
       setImgError(errorVal);
       setImgPlaceholder(true);
     } else {
       setFileTypeError('');
       setSrc(URL.createObjectURL(img));
       setModalOpen(true);
       if (img) {
         setImgPlaceholder(true);
       }
     }
     event.target.value = '';
   }
  
 }
  const handleCropSave = (blob) => {
   setImage(URL.createObjectURL(blob));
   const file = new File([blob], imageObj?.name, {lastModified: new Date()})
   props?.onImageHandleChange(file);
 }

 const handleCloseModal = () => {
  setModalOpen(false); // Close the modal
};
  return (
    <>
      <Button variant="contained" component="label" className="uploadBtn">
        <CommonCropImage
          modalOpen={modalOpen}
          src={src}
          setModalOpen={setModalOpen}
          handleCropSave={handleCropSave}
          handleCloseModal={handleCloseModal}
        />
        <img
          src={
            image && image != null
              ? image
              : props?.defaultValues?.avtar?.url
              ? props?.defaultValues?.avtar?.url
              : profile
          }
          alt="profile"
          className="imgFormSize"
        />
        {src && (
          <img
            src={src}
            alt="profile"
            className="imgFormSize displayNone"
            onError={handleErrorImg}
          />
        )}
        <div className="imgOuter">
          <img src={camera} alt="camera" />
        </div>
        <input
          type="file"
          {...register(props?.name, {
            onChange: (e) => onImageChange(e),
          })}
          hidden
          accept="image/*"
        />
      </Button>
      {props?.defaultValues?.avtar?.url || imgPlaceholder ? (
        ""
      ) : (
        <div className="errorMessage">Image is required</div>
      )}
      {imgError && imgError !== null && (
        <div className="errorMessage">{imgError}</div>
      )}
      {fileTypeError && fileTypeError !== null && (
        <div className="errorMessage">{fileTypeError}</div>
      )}
    </>
  );
}

export default CommonCropUpload;
